export const merchantPublicProfileTranslations = {
  en: {
    'merchantPublicProfile.noId': 'Merchant ID is required',
    'merchantPublicProfile.noIdHint': 'Open this page from a valid store or payment link.',
    'merchantPublicProfile.storeNotFound': "We couldn't load this store",
    'merchantPublicProfile.notFoundHelp':
      'The link may be wrong, or this store may not have a public profile yet. Try again from the marketplace, or check the store or payment link you were given.',
    'merchantPublicProfile.loadingError': 'Failed to load merchant information',
    'merchantPublicProfile.loading': 'Loading merchant profile...',
    'merchantPublicProfile.notFound': 'Merchant profile not found',
    'merchantPublicProfile.pay': 'Pay {name}',
    'merchantPublicProfile.verified': 'Verified',
    'merchantPublicProfile.aiMenu': '📸 AI Menu',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Manual',
    'merchantPublicProfile.established': 'Est. {year}',
    'merchantPublicProfile.reviews': '({count} reviews)',
    'merchantPublicProfile.getDirections': 'Get Directions',
    'merchantPublicProfile.contactInfo': 'Contact Information',
    'merchantPublicProfile.noContactInfo': 'No contact information available',
    'merchantPublicProfile.followUs': 'Follow Us',
    'merchantPublicProfile.closed': 'Closed',
    'merchantPublicProfile.ownerPreviewTitle': 'Private preview',
    'merchantPublicProfile.ownerPreviewBody':
      "You're signed in as this merchant. This is how your storefront looks to you; it is not visible to the public until you publish it in merchant settings.",
    'merchantPublicProfile.backToMarketplace': 'Back to marketplace',
    'merchantPublicProfile.backToSearchResults': 'Back to search results',
    'merchantPublicProfile.loadingPhotos': 'Loading store photos…',
    'merchantPublicProfile.photosTitle': 'Photos',
    'merchantPublicProfile.menuTitle': 'Menu',
    'merchantPublicProfile.photoPrevious': 'Previous',
    'merchantPublicProfile.photoNext': 'Next',
    'merchantPublicProfile.photoCounter': '{current} of {total}',
    'merchantPublicProfile.photoThumbnailAlt': '{name} photo {index}',
  },
  es: {
    'merchantPublicProfile.noId': 'Se requiere el ID del comerciante',
    'merchantPublicProfile.noIdHint': 'Abre esta página desde un enlace válido de tienda o pago.',
    'merchantPublicProfile.storeNotFound': 'No pudimos cargar esta tienda',
    'merchantPublicProfile.notFoundHelp':
      'El enlace puede ser incorrecto o la tienda aún no tiene perfil público. Vuelve al mercado o revisa el enlace que recibiste.',
    'merchantPublicProfile.loadingError': 'No se pudo cargar la información del comerciante',
    'merchantPublicProfile.loading': 'Cargando perfil del comerciante...',
    'merchantPublicProfile.notFound': 'Perfil del comerciante no encontrado',
    'merchantPublicProfile.pay': 'Pagar a {name}',
    'merchantPublicProfile.verified': 'Verificado',
    'merchantPublicProfile.aiMenu': '📸 Menú IA',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Manual',
    'merchantPublicProfile.established': 'Est. {year}',
    'merchantPublicProfile.reviews': '({count} reseñas)',
    'merchantPublicProfile.getDirections': 'Obtener Direcciones',
    'merchantPublicProfile.contactInfo': 'Información de Contacto',
    'merchantPublicProfile.noContactInfo': 'No hay información de contacto disponible',
    'merchantPublicProfile.followUs': 'Síguenos',
    'merchantPublicProfile.closed': 'Cerrado',
    'merchantPublicProfile.ownerPreviewTitle': 'Vista previa privada',
    'merchantPublicProfile.ownerPreviewBody':
      'Has iniciado sesión como este comerciante. Así se ve tu tienda para ti; el público no la verá hasta que la publiques en la configuración del comerciante.',
  },
  fr: {
    'merchantPublicProfile.noId': 'L\'ID du marchand est requis',
    'merchantPublicProfile.noIdHint': 'Ouvrez cette page depuis un lien boutique ou paiement valide.',
    'merchantPublicProfile.storeNotFound': 'Impossible de charger cette boutique',
    'merchantPublicProfile.notFoundHelp':
      'Le lien est peut‑être incorrect ou la boutique n’a pas encore de profil public. Réessayez depuis la marketplace ou vérifiez le lien reçu.',
    'merchantPublicProfile.loadingError': 'Échec du chargement des informations du marchand',
    'merchantPublicProfile.loading': 'Chargement du profil du marchand...',
    'merchantPublicProfile.notFound': 'Profil du marchand introuvable',
    'merchantPublicProfile.pay': 'Payer {name}',
    'merchantPublicProfile.verified': 'Vérifié',
    'merchantPublicProfile.aiMenu': '📸 Menu IA',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Manuel',
    'merchantPublicProfile.established': 'Établi en {year}',
    'merchantPublicProfile.reviews': '({count} avis)',
    'merchantPublicProfile.getDirections': 'Obtenir l\'itinéraire',
    'merchantPublicProfile.contactInfo': 'Informations de contact',
    'merchantPublicProfile.noContactInfo': 'Aucune information de contact disponible',
    'merchantPublicProfile.followUs': 'Suivez-nous',
    'merchantPublicProfile.closed': 'Fermé',
    'merchantPublicProfile.ownerPreviewTitle': 'Aperçu privé',
    'merchantPublicProfile.ownerPreviewBody':
      'Vous êtes connecté en tant que ce marchand. Voici l’apparence de votre vitrine pour vous ; le public ne la verra pas tant que vous ne l’aurez pas publiée dans les paramètres marchand.',
  },
  sq: {
    'merchantPublicProfile.noId': 'ID e tregtarit është e nevojshme',
    'merchantPublicProfile.noIdHint': 'Open this page from a valid store or payment link.',
    'merchantPublicProfile.storeNotFound': "We couldn't load this store",
    'merchantPublicProfile.notFoundHelp':
      'The link may be wrong, or this store may not have a public profile yet. Try again from the marketplace, or check the store or payment link you were given.',
    'merchantPublicProfile.loadingError': 'Dështoi ngarkimi i informacionit të tregtarit',
    'merchantPublicProfile.loading': 'Duke ngarkuar profilin e tregtarit...',
    'merchantPublicProfile.notFound': 'Profili i tregtarit nuk u gjet',
    'merchantPublicProfile.pay': 'Paguaj {name}',
    'merchantPublicProfile.verified': 'I verifikuar',
    'merchantPublicProfile.aiMenu': '📸 Menyja AI',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Manual',
    'merchantPublicProfile.established': 'Them. {year}',
    'merchantPublicProfile.reviews': '({count} vlerësime)',
    'merchantPublicProfile.getDirections': 'Merrni Udhëzime',
    'merchantPublicProfile.contactInfo': 'Informacioni i Kontaktit',
    'merchantPublicProfile.noContactInfo': 'Nuk ka informacion kontakti i disponueshëm',
    'merchantPublicProfile.followUs': 'Na Ndiqni',
    'merchantPublicProfile.closed': 'E Mbyllur',
    'merchantPublicProfile.ownerPreviewTitle': 'Private preview',
    'merchantPublicProfile.ownerPreviewBody':
      "You're signed in as this merchant. This is how your storefront looks to you; it is not visible to the public until you publish it in merchant settings.",
  },
  ru: {
    'merchantPublicProfile.noId': 'Требуется ID продавца',
    'merchantPublicProfile.noIdHint': 'Open this page from a valid store or payment link.',
    'merchantPublicProfile.storeNotFound': "We couldn't load this store",
    'merchantPublicProfile.notFoundHelp':
      'The link may be wrong, or this store may not have a public profile yet. Try again from the marketplace, or check the store or payment link you were given.',
    'merchantPublicProfile.loadingError': 'Не удалось загрузить информацию о продавце',
    'merchantPublicProfile.loading': 'Загрузка профиля продавца...',
    'merchantPublicProfile.notFound': 'Профиль продавца не найден',
    'merchantPublicProfile.pay': 'Оплатить {name}',
    'merchantPublicProfile.verified': 'Проверено',
    'merchantPublicProfile.aiMenu': '📸 AI Меню',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Ручной',
    'merchantPublicProfile.established': 'Основан {year}',
    'merchantPublicProfile.reviews': '({count} отзывов)',
    'merchantPublicProfile.getDirections': 'Получить маршрут',
    'merchantPublicProfile.contactInfo': 'Контактная информация',
    'merchantPublicProfile.noContactInfo': 'Контактная информация недоступна',
    'merchantPublicProfile.followUs': 'Подписаться',
    'merchantPublicProfile.closed': 'Закрыто',
    'merchantPublicProfile.ownerPreviewTitle': 'Private preview',
    'merchantPublicProfile.ownerPreviewBody':
      "You're signed in as this merchant. This is how your storefront looks to you; it is not visible to the public until you publish it in merchant settings.",
  },

  de: {
    'merchantPublicProfile.noId': 'Händler-ID ist erforderlich',
    'merchantPublicProfile.noIdHint': 'Öffnen Sie diese Seite über einen gültigen Shop- oder Zahlungslink.',
    'merchantPublicProfile.storeNotFound': 'Dieser Shop konnte nicht geladen werden',
    'merchantPublicProfile.notFoundHelp':
      'Der Link ist möglicherweise falsch oder der Shop hat noch kein öffentliches Profil. Versuchen Sie es erneut über die Marktplatzseite oder prüfen Sie Ihren Link.',
    'merchantPublicProfile.loadingError': 'Händlerinformationen konnten nicht geladen werden',
    'merchantPublicProfile.loading': 'Händlerprofil wird geladen...',
    'merchantPublicProfile.notFound': 'Händlerprofil nicht gefunden',
    'merchantPublicProfile.pay': '{name} bezahlen',
    'merchantPublicProfile.verified': 'Verifiziert',
    'merchantPublicProfile.aiMenu': '📸 KI-Menü',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Manuell',
    'merchantPublicProfile.established': 'Gegr. {year}',
    'merchantPublicProfile.reviews': '({count} Bewertungen)',
    'merchantPublicProfile.getDirections': 'Wegbeschreibung abrufen',
    'merchantPublicProfile.contactInfo': 'Kontaktinformationen',
    'merchantPublicProfile.noContactInfo': 'Keine Kontaktinformationen verfügbar',
    'merchantPublicProfile.followUs': 'Folgen Sie uns',
    'merchantPublicProfile.closed': 'Geschlossen',
    'merchantPublicProfile.ownerPreviewTitle': 'Private Vorschau',
    'merchantPublicProfile.ownerPreviewBody':
      'Sie sind als dieser Händler angemeldet. So sieht Ihr Schaufenster für Sie aus; für die Öffentlichkeit ist es sichtbar, sobald Sie es in den Händlereinstellungen veröffentlichen.',
  },

  sr: {
    'merchantPublicProfile.noId': 'ИД трговца је обавезан',
    'merchantPublicProfile.noIdHint': 'Open this page from a valid store or payment link.',
    'merchantPublicProfile.storeNotFound': "We couldn't load this store",
    'merchantPublicProfile.notFoundHelp':
      'The link may be wrong, or this store may not have a public profile yet. Try again from the marketplace, or check the store or payment link you were given.',
    'merchantPublicProfile.loadingError': 'Није успело учитавање информација о трговцу',
    'merchantPublicProfile.loading': 'Учитавање профила трговца...',
    'merchantPublicProfile.notFound': 'Профил трговца није пронађен',
    'merchantPublicProfile.pay': 'Плати {name}',
    'merchantPublicProfile.verified': 'Верификовано',
    'merchantPublicProfile.aiMenu': '📸 АИ мени',
    'merchantPublicProfile.google': '🗺 Гоогле',
    'merchantPublicProfile.manual': '✏ Ручно',
    'merchantPublicProfile.established': 'Основано {year}',
    'merchantPublicProfile.reviews': '({count} рецензија)',
    'merchantPublicProfile.getDirections': 'Добиј упутства',
    'merchantPublicProfile.contactInfo': 'Контакт информације',
    'merchantPublicProfile.noContactInfo': 'Нема доступних контакт информација',
    'merchantPublicProfile.followUs': 'Пратите нас',
    'merchantPublicProfile.closed': 'Затворено',
    'merchantPublicProfile.ownerPreviewTitle': 'Private preview',
    'merchantPublicProfile.ownerPreviewBody':
      "You're signed in as this merchant. This is how your storefront looks to you; it is not visible to the public until you publish it in merchant settings.",
  },
  pl: {
    'merchantPublicProfile.noId': 'Wymagany identyfikator sprzedawcy',
    'merchantPublicProfile.noIdHint': 'Open this page from a valid store or payment link.',
    'merchantPublicProfile.storeNotFound': "We couldn't load this store",
    'merchantPublicProfile.notFoundHelp':
      'The link may be wrong, or this store may not have a public profile yet. Try again from the marketplace, or check the store or payment link you were given.',
    'merchantPublicProfile.loadingError': 'Nie udało się załadować informacji o sprzedawcy',
    'merchantPublicProfile.loading': 'Ładowanie profilu sprzedawcy...',
    'merchantPublicProfile.notFound': 'Nie znaleziono profilu sprzedawcy',
    'merchantPublicProfile.pay': 'Zapłać {name}',
    'merchantPublicProfile.verified': 'Zweryfikowano',
    'merchantPublicProfile.aiMenu': '📸 Menu AI',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Ręczne',
    'merchantPublicProfile.established': 'Założono {year}',
    'merchantPublicProfile.reviews': '({count} recenzji)',
    'merchantPublicProfile.getDirections': 'Pobierz wskazówki',
    'merchantPublicProfile.contactInfo': 'Informacje kontaktowe',
    'merchantPublicProfile.noContactInfo': 'Brak dostępnych informacji kontaktowych',
    'merchantPublicProfile.followUs': 'Śledź nas',
    'merchantPublicProfile.closed': 'Zamknięte',
    'merchantPublicProfile.ownerPreviewTitle': 'Private preview',
    'merchantPublicProfile.ownerPreviewBody':
      "You're signed in as this merchant. This is how your storefront looks to you; it is not visible to the public until you publish it in merchant settings.",
  },
  el: {
    'merchantPublicProfile.noId': 'Απαιτείται ID εμπόρου',
    'merchantPublicProfile.noIdHint': 'Open this page from a valid store or payment link.',
    'merchantPublicProfile.storeNotFound': "We couldn't load this store",
    'merchantPublicProfile.notFoundHelp':
      'The link may be wrong, or this store may not have a public profile yet. Try again from the marketplace, or check the store or payment link you were given.',
    'merchantPublicProfile.loadingError': 'Αποτυχία φόρτωσης πληροφοριών εμπόρου',
    'merchantPublicProfile.loading': 'Φόρτωση προφίλ εμπόρου...',
    'merchantPublicProfile.notFound': 'Το προφίλ εμπόρου δεν βρέθηκε',
    'merchantPublicProfile.pay': 'Πληρωμή {name}',
    'merchantPublicProfile.verified': 'Επαληθευμένο',
    'merchantPublicProfile.aiMenu': '📸 Μενού AI',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Χειροκίνητο',
    'merchantPublicProfile.established': 'Ιδρ. {year}',
    'merchantPublicProfile.reviews': '({count} αξιολογήσεις)',
    'merchantPublicProfile.getDirections': 'Λήψη Οδηγιών',
    'merchantPublicProfile.contactInfo': 'Στοιχεία Επικοινωνίας',
    'merchantPublicProfile.noContactInfo': 'Δεν υπάρχουν διαθέσιμες πληροφορίες επικοινωνίας',
    'merchantPublicProfile.followUs': 'Ακολουθήστε μας',
    'merchantPublicProfile.closed': 'Κλειστό',
    'merchantPublicProfile.ownerPreviewTitle': 'Private preview',
    'merchantPublicProfile.ownerPreviewBody':
      "You're signed in as this merchant. This is how your storefront looks to you; it is not visible to the public until you publish it in merchant settings.",
  },
  ro: {
    'merchantPublicProfile.noId': 'ID-ul comerciantului este necesar',
    'merchantPublicProfile.noIdHint': 'Open this page from a valid store or payment link.',
    'merchantPublicProfile.storeNotFound': "We couldn't load this store",
    'merchantPublicProfile.notFoundHelp':
      'The link may be wrong, or this store may not have a public profile yet. Try again from the marketplace, or check the store or payment link you were given.',
    'merchantPublicProfile.loadingError': 'Eșec la încărcarea informațiilor comerciantului',
    'merchantPublicProfile.loading': 'Se încarcă profilul comerciantului...',
    'merchantPublicProfile.notFound': 'Profilul comerciantului nu a fost găsit',
    'merchantPublicProfile.pay': 'Plătește {name}',
    'merchantPublicProfile.verified': 'Verificat',
    'merchantPublicProfile.aiMenu': '📸 Meniu AI',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Manual',
    'merchantPublicProfile.established': 'Înființat {year}',
    'merchantPublicProfile.reviews': '({count} recenzii)',
    'merchantPublicProfile.getDirections': 'Obține Direcții',
    'merchantPublicProfile.contactInfo': 'Informații de Contact',
    'merchantPublicProfile.noContactInfo': 'Nu sunt disponibile informații de contact',
    'merchantPublicProfile.followUs': 'Urmărește-ne',
    'merchantPublicProfile.closed': 'Închis',
    'merchantPublicProfile.ownerPreviewTitle': 'Private preview',
    'merchantPublicProfile.ownerPreviewBody':
      "You're signed in as this merchant. This is how your storefront looks to you; it is not visible to the public until you publish it in merchant settings.",
  },
  pt: {
    'merchantPublicProfile.noId': 'ID do comerciante é necessário',
    'merchantPublicProfile.noIdHint': 'Abra esta página a partir de um link válido de loja ou pagamento.',
    'merchantPublicProfile.storeNotFound': 'Não foi possível carregar esta loja',
    'merchantPublicProfile.notFoundHelp':
      'O link pode estar incorreto ou a loja ainda não tem perfil público. Tente de novo pelo marketplace ou confira o link recebido.',
    'merchantPublicProfile.loadingError': 'Falha ao carregar informações do comerciante',
    'merchantPublicProfile.loading': 'Carregando perfil do comerciante...',
    'merchantPublicProfile.notFound': 'Perfil do comerciante não encontrado',
    'merchantPublicProfile.pay': 'Pagar {name}',
    'merchantPublicProfile.verified': 'Verificado',
    'merchantPublicProfile.aiMenu': '📸 Menu IA',
    'merchantPublicProfile.google': '🗺️ Google',
    'merchantPublicProfile.manual': '✏️ Manual',
    'merchantPublicProfile.established': 'Est. {year}',
    'merchantPublicProfile.reviews': '({count} avaliações)',
    'merchantPublicProfile.getDirections': 'Obter Direções',
    'merchantPublicProfile.contactInfo': 'Informações de Contato',
    'merchantPublicProfile.noContactInfo': 'Nenhuma informação de contato disponível',
    'merchantPublicProfile.followUs': 'Siga-nos',
    'merchantPublicProfile.closed': 'Fechado',
    'merchantPublicProfile.ownerPreviewTitle': 'Pré-visualização privada',
    'merchantPublicProfile.ownerPreviewBody':
      'Você está conectado como este comerciante. É assim que sua vitrine aparece para você; o público não verá até você publicá-la nas configurações do comerciante.',
  },
};
